import { ServerValueEnum } from '../../utils/enum'

const PresenceStatus = new ServerValueEnum({
  UNKNOWN:     { serverValue: 'unknown' },
  AVAILABLE:   { serverValue: 'available' },
  UNAVAILABLE: { serverValue: 'unavailable' },
})

export default PresenceStatus
